<template>
    <section class="card-container" ref="modal" v-if="isVisible">
        <!-- <div ref="card" :class="!isSuccess ? 'card-modal' : 'card-modal-success'"> -->
        <div ref="card" class="card-modal-success">
            <div class="card-header-success">
                <v-icon color="white" size="84" v-if="!isSuccess && !changeModal">
                    mdi-close-circle-outline
                </v-icon>
                <img src="https://storage.googleapis.com/wp-bucket-tcc/channel/images/profile/mail-logo.png" alt="mail-logo" v-else-if="isSuccess && !changeModal"/>
                <v-icon color="white" size="84" v-else>
                    mdi-close-circle-outline
                </v-icon> 

                <span class="button-close" @click="logout()">
                    <v-icon color="#5DDEAD" size="40">
                        mdi-close-circle-outline
                    </v-icon>
                </span>
            </div>

            <div class="card-content" v-if="!isSuccess && !changeModal">
                <h5 class="header-text">REGISTRO INVÁLIDO</h5>
                <p :class=" message ? 'message-text' : 'paragraph-text'">
                   {{ message ? message : 'Ingresa los datos correspondientes para que disfrutes de nuestro servicio.' }}
                </p>
            </div>

            <div class="card-success-content" v-else-if="isSuccess && !changeModal">
                <h5 class="card-text-success">Registro exitoso</h5>
                <p class="paragraph-success">
                    Enviamos un correo de verificación a
                    <span class="email-success">{{ email ? email : 'xxxxxx@gmail.com' }}</span>
                </p>

                <p class="paragraph-success-second">
                    <!-- Gracias por elegir una manera rápida, segura y efectiva 24/7 -->
                    Ingresa el codigo para activar tu cuenta y comenzar a disfrutar de todos nuestros servicios.
                </p>

                <v-row justify="center" class="container-authcode">
                    <v-col class="my-0 py-0" cols="8" >
                        <v-text-field
                              v-model="authCode"
                              label="Tu código"
                              solo
                              class="text-field authcode-input"
                        />
                        <p class="timer-authcode" v-if="countdownEnable">Código vigente: {{ minutes > 9 ? minutes : `0${minutes}` }}:{{ seconds > 9 ? seconds : `0${seconds}` }}</p>
                        <p class="resend-button" v-else @click="GetCode">Reenviar código</p>
                        <p class="error-code" v-if="errorMsg">{{ errorMsg }}</p>
                    </v-col>
                </v-row>

                <ul class="list-item-success">
                    <li>
                        <v-icon color="#5DDEAD">
                            mdi-check
                        </v-icon>
                        Gestiona tus envíos
                    </li>

                    <li>
                        <v-icon color="#5DDEAD">
                            mdi-check
                        </v-icon>
                        Todo en tiempo de 24/7
                    </li>

                    <li>
                        <v-icon color="#5DDEAD">
                            mdi-check
                        </v-icon>
                        Con el mejor respaldo logístico
                    </li>
                </ul>

            </div>

            <div id="card-extra" class="card-content" v-else>
                <h5 class="header-text">Código incorrecto</h5>
                <p class="message-text">
                   {{ "Lo sentimos , el código de verificación que ingresaste es incorrecto"}}
                </p>
                <p class="message-text">
                   {{ "Por favor, verifica el código que has recibido en tu correo electrónico y asegúrate de ingresarlo correctamente."}}
                </p>
            </div>

            <v-row justify="center" class="py-8 px-5 container-submit-btn">
                <v-btn rounded
                       @click="submitCode()"
                       class="white--text"
                       :color="!isSuccess ? '#ffa141' : '#5DDEAD'"
                       :loading="loading"
                       v-if="!isSuccess || changeModal"
                >
                  Aceptar
                </v-btn>
                <v-btn rounded
                    @click="submitCode()"
                    class="white--text"
                    :color="!isSuccess ? '#ffa141' : '#5DDEAD'"
                    :loading="loading"
                    :disabled="authCode.length<=0"
                    v-else
                >
                    Entendido
                </v-btn>

            </v-row>
        </div>
    </section>
</template>

<script>
import { post } from "@/services/apiService";

export default {
    props: ['isVisible', 'isSuccess', 'email', 'message'],
    mounted(){
        if(window.location.href.includes("/profile")){
            this.GetTime();
        }
    },
    data: () => ({
      isClose: false,
      authCode: "",
      countdownEnable: false,
      loading: false,
      errorMsg: "",
      timeStart: 180, //3min en segundos
      timeRest: 180,
      countTimes: 0,
      changeModal: false,
    }),
    computed: {
        minutes(){
            return Math.floor(this.timeRest / 60);
        },
        seconds(){
            return this.timeRest % 60;
        }
    },
    methods: {
        async GetTime(){
            const dataSend = { 
                email: this.email,
            };
            const response = await post('channel/api/auth/get-time', dataSend);

            if(response.success && response.data.time){
                if(response.data.time > this.timeStart){
                    this.countdownEnable = false;
                }
                else{
                    this.countdownEnable = true;
                    this.timeRest = this.timeStart - response.data.time;
                }
            }
            else {
                // Sin tiempo registrado, o la consulta falló (transporte/backend):
                // en ambos casos intentamos pedir un código nuevo.
                this.GetCode();
            }
        },
        async submitCode () {
            this.loading = true;

            if(this.isSuccess && !this.changeModal){
                const dataSend = { 
                    email: this.email,
                    codeInput: this.authCode
                };
    
                const response = await post('channel/api/auth/validate-code', dataSend);

                if(!response.success || !response.data){
                    // Falla de transporte/backend (timeout, red, 5xx) o un 200 con
                    // body vacío/malformado: en ambos casos no es el flujo de
                    // "código incorrecto", que solo aplica si el backend
                    // respondió correctamente con datos.
                    this.errorMsg = "No se pudo validar el código, intenta de nuevo.";
                    setTimeout(() => {
                        this.loading = false;
                        this.errorMsg = "";
                    }, 4000);
                    return
                }

                if(response.data.status == "error"){
                    this.errorMsg = response.data.message;
                    this.CountingTimes();
                    setTimeout(() => {
                        this.loading = false;
                        this.errorMsg = "";
                    }, 2000);
                    return
                }
            }

            if(!this.changeModal){
                this.$emit('closeModalRegister')
            }
            else {
                this.changeModal = false;
            }

            //iniciamos el modal de nuevo registro
            this.$emit('toggleAdvancedRegister', true);

            setTimeout(() => {
                this.loading = false;
            }, 2000);
        },
        async GetCode(){
            this.countdownEnable = true;

            const dataSend = { 
                email: this.email
            };

            const newCode = await post('channel/api/auth/send-code', dataSend);

            if (!newCode.success){
                // El envío falló: revertimos el timer para que reaparezca "Reenviar código".
                // apiService.post() nunca rechaza ni resuelve a un Error, por eso se
                // valida con `success` y no con `instanceof Error`.
                this.countdownEnable = false;
                this.errorMsg = "No se pudo enviar el código, intenta de nuevo.";
                setTimeout(() => { this.errorMsg = ""; }, 4000);
                return
            }

            //reiniciamos el tiempo del timer
            this.timeRest = this.timeStart - newCode.data.time;
        },
        startTimer(){
            this.interval = setInterval(() => {
                if (this.timeRest > 0) {
                    this.timeRest--;
                } else {
                    clearInterval(this.interval);
                    this.countdownEnable = false;
                }
            }, 1000);
        },
        stopTimer(){
            clearInterval(this.interval);
        },
        CountingTimes() {
            this.countTimes++;
            if(this.countTimes >= 2){
                //aqui la logica para mostrar el error en pantalla
                this.changeModal = true;
                this.countTimes = 0;
            }
        },
        logout() {
            this.$store.dispatch("logout");
            this.$router.push({ name: "login" });
            this.$emit("logout");
        },
   },
   watch: {
        countdownEnable(newValue, lastValue){
            if (newValue && !lastValue) {
                this.startTimer();
            } else if (!newValue && lastValue) {
                this.stopTimer();
            }
        }
    }
}
</script>

<style lang="scss" scoped>
   @import "../../scss/modal-register.scss";
</style>
